import { Document } from '@tiptap/extension-document'
import { Paragraph } from '@tiptap/extension-paragraph'
import { Bold } from '@tiptap/extension-bold'
import { Italic } from '@tiptap/extension-italic'
import { Underline } from '@tiptap/extension-underline'
import { Strike } from '@tiptap/extension-strike'
import { BulletList } from '@tiptap/extension-bullet-list'
import { OrderedList } from '@tiptap/extension-ordered-list'
import { ListItem } from '@tiptap/extension-list-item'
import { HardBreak } from '@tiptap/extension-hard-break'
import { Placeholder } from '@tiptap/extension-placeholder'
import { CustomHighlight } from './CustomHighlightExtension.mjs'
import { Text } from '@tiptap/extension-text'
import { History } from '@tiptap/extension-history'
import { TabHandlerExtension } from './TabHandlerExtension.mjs'

/**
 * A list of bare-minimum TipTap extensions.  This list is used as the default
 * list of extensions for the TipTap editor.  Applications may add more
 * extensions to this list by calling activeTipTapExtensions.add(), or they can
 * use this list to create their own entirely custom list of extensions.  If you're
 * just making a text editor from scratch, prefer activeTipTapExtensions.get().
 */
export const tipTapExtensions = [
  Document,
  Paragraph,
  Text,
  Bold,
  Italic,
  Underline.extend({
    addStorage() {
      return {
        markdown: {
          serialize: {
            open(state, mark) {
              return ''
            },
            close(state, mark) {
              return ''
            },
          },
        },
      }
    },
  }),
  Strike,
  BulletList,
  OrderedList,
  ListItem,
  History,
  HardBreak,
  Placeholder.configure({
    placeholder: 'Begin typing here...',
  }),
  CustomHighlight,
  TabHandlerExtension,
]
